import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';

import BaseToast from './baseToast';

import { actionCreators as toastAlertsCreators } from 'react/api/actions/toastAlerts';
import { push } from 'connected-react-router';
import { getResourceTo } from 'react/utils/utils';

const LogsFeedbackScheduled = ({
  toastData
}) => {
  const dispatch = useDispatch();

  function removeThisToast() {
    dispatch(toastAlertsCreators.removeToast({ id: toastData.get('id') }));
  }

  function handleSeeLogsPage() {
    const integrationId = toastData.getIn(['data', 'integrationId']);

    dispatch(push(`/Integrations/logs/${integrationId}`));

    removeThisToast();
  }

  const header = () => (
    <>
      <h4>
        <span className="info-icon" />
        {getResourceTo(toastData.getIn(['data', 'title']))}
      </h4>
      <span 
        data-testid={`remove-toast-${toastData.get('id')}`}
        className="close-icon" 
        onClick={removeThisToast} 
        alt="Close Icon" 
      />
    </>
  );

  const body = () => (
    <p>
      {getResourceTo('Integration.scheduledToastFeedback.description', toastData.getIn(['data', 'integrationName']))}
    </p>
  );

  const footer = () => (
    <>
      <input
        data-testid={`confirmAction-toast-${toastData.get('id')}`}
        type="button"
        value={getResourceTo('IntegrationCard.ViewLogsButton')}
        onClick={handleSeeLogsPage}
      />
    </>
  );

  return (
    <BaseToast
      toastId={toastData.get('id')}
      className={String(toastData.get('type'))}
      header={header()}
      body={body()}
      footer={footer()}
      data-testid={`logsFeedbackScheduled-toast-${toastData.get('type')}-${toastData.get('id')}`}
    />
  );
};

LogsFeedbackScheduled.propTypes = {
  toastData: PropTypes.object.isRequired
};

export default LogsFeedbackScheduled;
